// slices/userSlice.ts
import { StateCreator } from "zustand";
import { ItineraryV2User } from "@/types/itinerary/itineraryV2";

export interface UserSlice {
  users: { [key: string]: ItineraryV2User } | null;
  itineraryUser: ItineraryV2User | null;
  setItineraryUser: (user: ItineraryV2User) => void;
  setUsers: (users: ItineraryV2User[]) => void;
  addUser: (user: ItineraryV2User) => void;
  deleteUserById: (userId: string) => void;
  setOneUser: (user: ItineraryV2User) => void;
}

export const createUserSlice: StateCreator<UserSlice> = (set) => ({
  users: null,
  itineraryUser: null,
  setItineraryUser: (user) => set({ itineraryUser: user }),
  setUsers: (users) => {
    const newUser: { [key: string]: ItineraryV2User } = {};
    users.map((item) => {
      newUser[item.userId] = item;
    });
    set({ users: newUser });
  },
  addUser: (user) =>
    set((state) => ({
      users: { ...state.users, [user.userId]: user },
    })),
  deleteUserById: (userId) =>
    set((state) => {
      const newUsers = { ...state.users };
      delete newUsers[userId];
      return {
        users: newUsers,
      };
    }),
  setOneUser: (user) =>
    set((state) => {
      if (state.users && state.users[user.userId]) {
        const updatedUsers = { ...state.users };
        updatedUsers[user.userId] = user;
        return { users: updatedUsers };
      } else {
        return { users: { ...state.users, [user.userId]: user } };
      }
    }),
});
